import React from 'react';
import { Route, Routes, Navigate } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login/login";
// import Unauthorized from "./Unauthorized";
import ProtectedRoute from "./ProtectedRoute";
import TeacherDashboard from "../mainMenu/teacherDashboard/index";
import {  useSelector } from "react-redux";
// import { loginSuccess } from "../../core/data/redux/authSlice";
// import EditStudent from "../peoples/students/add-student/index";
import Editteacher from "../peoples/teacher/teacherForm/index";
import HeadmasterDashboard from "../mainMenu/headmasterDashboard";
import StudentDetail from "../peoples/students/student-details/studentDetails";
import { RootState } from "../../core/data/redux/store";
import MealSupervisorDashboard from '../mainMenu/mealSuperviserDashboard';
import AdminDashboard from '../mainMenu/adminDashboard';

const ALLRoutes: React.FC = () => {
	const accessToken = useSelector((state: RootState) => state.auth.accessToken);
	const userRole = useSelector((state: RootState) => state.auth.roleName);

	return (
		<>
			<Routes key={accessToken}>
				{/* Root Route - Redirect based on auth status */}
				<Route path="/" element={
					accessToken ? (
						// If logged in, redirect to appropriate dashboard based on role
						(() => {
							switch(userRole) {
								case 'headmaster':
									return <Navigate to="/hm/dashboard" replace />;
								case 'teacher':
									return <Navigate to="/teacher/dashboard" replace />;
								case 'mealSupervisor':
									return <Navigate to="/MealSupervisor/dashboard" replace />;
								case 'admin':
								case 'state-admin':
								case 'district-admin':
								case 'block-admin':
								case 'village-admin':
									return <Navigate to="/admin/dashboard" replace />;
								default:
									return <Navigate to="/admin/dashboard" replace />;
							}
						})()
					) : (
						// If not logged in, redirect to login
						<Navigate to="/login" replace />
					)
				} />

				{/* Public Login Route */}
				<Route path="/login" element={<Login />} />

				{/* Protected Routes with Feature (Sidebar + Header) */}
				<Route element={<ProtectedRoute />}>
					<Route element={<Feature />}>
						<Route path="/hm/dashboard" element={<HeadmasterDashboard />} />
						<Route path="/teacher/dashboard" element={<TeacherDashboard />} />
						<Route path='/MealSupervisor/dashboard' element={<MealSupervisorDashboard/>}/>
						<Route path='/admin/dashboard' element={<AdminDashboard/>}/>
						<Route path='/state-admin/dashboard' element={<AdminDashboard/>}/>
						<Route path='/district-admin/dashboard' element={<AdminDashboard/>}/>
						<Route path='/block-admin/dashboard' element={<AdminDashboard/>}/>
						<Route path='/village-admin/dashboard' element={<AdminDashboard/>}/>
						<Route
							path="/student/student-detail/:id"
							element={<StudentDetail />}
						/>
						<Route path="/teacher/edit-teacher" element={<Editteacher />} />
					</Route>
				</Route>

				{/* Public Routes */}
				<Route element={<Feature />}>
					{publicRoutes.map((route, idx) => (
						<Route path={route.path} element={route.element} key={idx} />
					))}
				</Route>

				{/* Auth Routes */}
				<Route element={<AuthFeature />}>
					{authRoutes.map((route, idx) => (
						<Route path={route.path} element={route.element} key={idx} />
					))}
				</Route>
			</Routes>
		</>
	);
};

export default ALLRoutes;
